import { useCallback, useEffect, useState } from 'react'
import * as React from 'react'
import DialogButton from '../../Common/Buttons/DialogButton'
import Dialog from '../../Common/Dialog/Dialog'
import DialogActions from '../../Common/Dialog/DialogActions'
import DialogContent from '../../Common/Dialog/DialogContent'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '../../Common/_hooks/useAppDispatch'
import { TextField } from '@mui/material'
import DialogTitle from '../../Common/Dialog/DialogTitle'
import { type CollectionStore } from '../../UserData/_stores/CollectionStore'
import { UpdateCollection } from '../../UserData/_actions/CollectionActions'

interface Props {
  collection: CollectionStore
  opened: boolean
  onClose: () => void
}

export default function EditCollectionDialog(props: Props) {
  const [t] = useTranslation('account-v2')
  const dispatch = useAppDispatch()

  const [name, setName] = useState(props.collection.get('name'))

  useEffect(() => {
    setName(props.collection.get('name'))
  }, [props.collection])

  const resetDialogState = useCallback(() => {
    setName(props.collection.get('name'))
  }, [props.collection])

  const onClose = useCallback(() => {
    props.onClose()
  }, [props.onClose])

  const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value)
  }, [])

  const onSubmit = useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    dispatch(UpdateCollection(
      props.collection.get('id'),
      name
    ).set({
      onSuccess: onClose
    }))
  }, [props.collection, onClose, name])

  return <Dialog
    open={props.opened}
    maxWidth="xs"
    fullWidth
    onClose={onClose}
    TransitionProps={{
      onExited: resetDialogState,
    }}
    showCloseButton
  >
    <form onSubmit={onSubmit}>
      <DialogTitle>{t('Edit Collection')}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          variant="filled"
          label={t('Name')}
          value={name}
          onChange={onChange}
        />
      </DialogContent>
      <DialogActions>
        <DialogButton
          color="secondary"
          onClick={onClose}
        >{t('Cancel')}</DialogButton>
        <DialogButton
          color="primary"
          type="submit"
          disabled={name === ''}
        >{t('Confirm')}</DialogButton>
      </DialogActions>
    </form>
  </Dialog>
}
